import { useEffect, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { useThemeStore } from '@/store/themeStore';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      gcTime: 5 * 60_000,
    },
    mutations: {
      retry: 0,
    },
  },
});

export function AppProviders({ children }: { children: ReactNode }) {
  const apply = useThemeStore((s) => s.apply);
  const resolved = useThemeStore((s) => s.resolved);

  useEffect(() => {
    apply();
  }, [apply]);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {children}
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: resolved === 'dark' ? '#1e293b' : '#ffffff',
              color: resolved === 'dark' ? '#f1f5f9' : '#111827',
              border: `1px solid ${resolved === 'dark' ? '#334155' : '#e5e7eb'}`,
              fontSize: '0.875rem',
            },
          }}
        />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
